import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-5aabd717")

_pushScopeId("data-v-5aabd717")
const _hoisted_1 = { class: "shape-pool" }
const _hoisted_2 = { class: "category-name" }
const _hoisted_3 = { class: "shape-list" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_SvgWrapper = _resolveComponent("SvgWrapper")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.shapeList, (item) => {
      return (_openBlock(), _createBlock("div", {
        class: "category",
        key: item.type
      }, [
        _createVNode("div", _hoisted_2, _toDisplayString(item.type), 1),
        _createVNode("div", _hoisted_3, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(item.children, (shape, index) => {
            return (_openBlock(), _createBlock("div", {
              class: "shape-item",
              key: index
            }, [
              _createVNode("div", {
                class: "shape-content",
                onClick: ($event: any) => (_ctx.selectShape(shape))
              }, [
                _createVNode(_component_SvgWrapper, {
                  overflow: "visible",
                  width: "18",
                  height: "18"
                }, {
                  default: _withId(() => [
                    _createVNode("g", {
                      transform: `scale(${18 / shape.viewBox}, ${18 / shape.viewBox}) translate(0,0) matrix(1,0,0,1,0,0)`
                    }, [
                      _createVNode("path", {
                        class: "shape-path",
                        "vector-effect": "non-scaling-stroke",
                        "stroke-linecap": "butt",
                        "stroke-miterlimit": "8",
                        "stroke-linejoin": "",
                        fill: "transparent",
                        stroke: "#999",
                        "stroke-width": "2",
                        d: shape.path
                      }, null, 8, ["d"])
                    ], 8, ["transform"])
                  ]),
                  _: 2
                }, 1024)
              ], 8, ["onClick"])
            ]))
          }), 128))
        ])
      ]))
    }), 128))
  ]))
})